var map = {
	"./en/addAmenity.json": 203,
	"./en/addItemSteps.json": 5839,
	"./en/common.json": 926,
	"./en/confirmStorageDetails.json": 7948,
	"./en/createOrder.json": 4017,
	"./en/guests.json": 2116,
	"./en/items.json": 4788,
	"./en/linenInventory.json": 4120,
	"./en/listOrders.json": 7234,
	"./en/lockDevices.json": 1797,
	"./en/login.json": 2730,
	"./en/orderDetails.json": 3442,
	"./en/prepareLinenOrder.json": 5253,
	"./en/reservations.json": 7432,
	"./en/saveOrder.json": 5739,
	"./en/settings.json": 1012,
	"./en/stockCount.json": 543,
	"./en/storageDetailsSection.json": 3835,
	"./en/storageLV.json": 6770,
	"./en/vendor.json": 5500,
	"./ja/addAmenity.json": 5740,
	"./ja/addItemSteps.json": 665,
	"./ja/common.json": 7828,
	"./ja/confirmStorageDetails.json": 4233,
	"./ja/createOrder.json": 7493,
	"./ja/guests.json": 9573,
	"./ja/items.json": 9099,
	"./ja/linenInventory.json": 4976,
	"./ja/listOrders.json": 3452,
	"./ja/lockDevices.json": 8001,
	"./ja/login.json": 2750,
	"./ja/orderDetails.json": 455,
	"./ja/prepareLinenOrder.json": 488,
	"./ja/reservations.json": 4520,
	"./ja/saveOrder.json": 7711,
	"./ja/settings.json": 5370,
	"./ja/stockCount.json": 9430,
	"./ja/storageDetailsSection.json": 4861,
	"./ja/storageLV.json": 8559,
	"./ja/vendor.json": 1783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2813;